/* import __COLOCATED_TEMPLATE__ from './ticket-form.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();